const FinanceIcon = () => {
  return (
    <svg viewBox="0 0 18 15.318">
      <path
        d="M32.468,47.367a.659.659,0,0,0-.32.083l-7.323,4a.664.664,0,1,0,.635,1.166l.349-.187v6.264h-.333a.666.666,0,1,0,0,1.332H39.461a.666.666,0,1,0,0-1.332h-.333V52.425l.346.187a.666.666,0,1,0,.64-1.166l-7.326-4A.659.659,0,0,0,32.468,47.367ZM31.8,50.7h1.332v1.077a1.77,1.77,0,0,1,1.53,1.639H33.54a.949.949,0,0,0-1.051-.749c-.6,0-.989.276-.989.71,0,.354.271.554.937.7l.689.146c1.147.242,1.639.736,1.639,1.621a1.775,1.775,0,0,1-1.631,1.785v1.067H31.8V57.625a1.775,1.775,0,0,1-1.631-1.665h1.153c.055.463.523.76,1.194.76.619,0,1.059-.3,1.059-.734,0-.362-.284-.572-.983-.721l-.741-.159c-1.04-.218-1.55-.76-1.55-1.629a1.726,1.726,0,0,1,1.5-1.7ZM24.143,61.353a.666.666,0,1,0,0,1.332h16.65a.666.666,0,1,0,0-1.332Z"
        transform="translate(-23.468 -47.367)"
      />
    </svg>
  );
};

export default FinanceIcon;
